import PropTypes from 'prop-types';
import React from 'react';

export class CardZeroState extends React.Component {
  render() {
    return (
      <div className="row h-100 align-items-center text-center">
        <div className="col appointment-container">
            <div className="fs-1">
              <span
                className={ 'fa-regular ' + (this.props.stateIconCss ? this.props.stateIconCss : '') }
              >
              </span>
              </div>
              <span tabIndex="0">{ this.props.zeroStateMessage }</span>
        </div>
      </div>
    );
  }
}

CardZeroState.propTypes = {
  zeroStateMessage: PropTypes.object,
  stateIconCss: PropTypes.string,
};
